module.exports = {"data":{"site":{"siteMetadata":{"languages":{"defaultLangKey":"fr","langs":["en","fr"]}}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-fr.json
// module id = 474
// module chunks = 20976610436329 60335399758886